export const API_PATH = '/promocode';
